/* @jsx h */
import { Fragment, h } from "preact";
import ListItem from "../ListItem";
import PropTypes from "prop-types";
import "./basic-list.scss";

/*
 * BasicLists are children of sublists. 
 * A BasicList has either all checked or all unchecked items.
 * This allows unchecked items to move easily to the end of the parent sublist.
 * @param sublistId is necessary since the sublistId is part of each item's unique id.
 */
function BasicList({ sublistId = "", items = [], checked = false }) {
    const createListItems = (items) =>
        items.map((item) => <ListItem key={item.id} item={item} checked={checked} sublistId={sublistId} />);

    return (
        <div className={checked ? "completed-todo-list" : "todo-list"}>
            {items.length > 0 && (
                <Fragment>
                    {checked && <p className="to-do-list-label">{`Collected items (${items.length})`}</p>}
                    {createListItems(items)}
                </Fragment>
            )}
        </div>
    );
}

BasicList.propTypes = {
    sublistId: PropTypes.string,
    items: PropTypes.array,
    checked: PropTypes.bool
};

export default BasicList;
